module.exports = __webpack_public_path__ + "static/media/work.572c80f6.jpg";